// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"976ac68d","549":"dbe74db7","781":"d41a274b","850":"a2bcd23b"}[chunkId] + ".chunk.js";
};